import React from 'react';
import { Conversation } from '../../../fasades/conversation';
import { TextAreaResize } from '../textarearesize';
import { FaCheck } from "react-icons/fa6";
import { FiEdit3 } from "react-icons/fi";
import { MdOutlineCancel } from "react-icons/md";
import './styles.css';
import './sysprompt.css';

interface ChatSysState
{
    editMode : boolean;
    hidden   : boolean;
    input    : string;
}

interface ChatSysProps
{
    show? : boolean;
}

export default class SysPrompt extends React.Component<ChatSysProps,ChatSysState>
{
    textareaRef : React.RefObject<TextAreaResize> = React.createRef() as React.RefObject<TextAreaResize>;

    constructor(props: ChatSysProps)
    {
        super(props);

        this.state = {
            editMode : false,
            hidden   : (this.props.show !== true),
            input    : Conversation.getSystemPrompt()
        }
        this.handleUpdate = this.handleUpdate.bind(this);
    }

    componentDidMount()
    {
        Conversation.onUpdate(this.handleUpdate);
    }

    componentWillUnmount()
    {
        Conversation.removeUpdateEvent(this.handleUpdate);
    }

    componentDidUpdate(prevProps : ChatSysProps, prevState : ChatSysState) 
    {
        if (this.props.show === true && prevProps.show !== this.props.show) {
            this.setState({hidden : false });
        }
    }

    onEdit()
    {
        this.setState({editMode : true });
    }

    onCancelEdit()
    {
        this.textareaRef.current.onCancel();
        this.setState({
            editMode : false
        });
    }

    onConfirmEdit()
    {
        const text = this.textareaRef.current.getText();
        Conversation.setSystemPrompt(text);
        this.setState({
            editMode : false,
            input    : text
        });
    }

    handleUpdate()
    {
        this.setState({ input : Conversation.getSystemPrompt() });
    }

    onShowHide()
    {
        this.setState({ hidden : !this.state.hidden }, () => {
            if (!this.state.hidden) {
            }
        });
    }

    render() {
        const dropDownBtn = this.readerDropDownButton();

        return (
          <div>
          { !this.state.hidden && (
            <div className={this.state.editMode ? "sysprompt edit" : "sysprompt"}>
                <TextAreaResize
                    editMode={this.state.editMode}
                    ref={this.textareaRef}
                    text={this.state.input}
                    className="textarea-sysprompt"/>
                <div className="sysprompt-actions">
                    { !this.state.editMode && (
                        <>
                        <button title="Edit" onClick={() => this.onEdit()}>
                            {React.createElement(FiEdit3 as React.ComponentType)}
                        </button>
                        </>)
                    }
                    { this.state.editMode && (
                    <>
                        <button title="Confirm edit" onClick={() => this.onConfirmEdit()}>
                            {React.createElement(FaCheck as React.ComponentType)}
                        </button>
                        <button className="redbutton" title="Cancel edit" onClick={() => this.onCancelEdit()}>
                            {React.createElement(MdOutlineCancel as React.ComponentType)}
                        </button>
                    </>)}
                </div>
            </div>)
          }
          { (this.state.hidden && (this.props.show === undefined || this.props.show === true)) && (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 0,
                    width: "100%"
                }}>
                     {dropDownBtn}
                </div>)
          }
          </div>
        );
    }

    readerDropDownButton() : React.JSX.Element
    {
        return (
            <button disabled={this.state.editMode} onClick={() => this.onShowHide()}>
              <svg
                   width="300px"
                   height="45px"
                   viewBox="0 0 300 45"
                   version="1.1"
                   id="svg1"
                   xmlns="http://www.w3.org/2000/svg">
                <g transform="scale(1.5)">
                  <path
                    d="M 0,0 200,0 
                       C 200,10 190,20 120,20
                       L 80, 20
                       C 10,20 0,10 0,-1"
                    fill={this.state.editMode ? "#C0C0C0" : "#3498db"}
                    stroke={this.state.editMode ? "#B8B8B8" : "#2980b9"}
                    strokeWidth="2"/>
                  <text
                     style={{
                        fontSize:   "11px",
                        textAlign:  "start",
                        direction:  "ltr",
                        textAnchor: "start",
                        fill:       this.state.editMode ? "#B0B0B0" : "#FFFFFF"
                     }}
                     x="46"
                     y="13"
                     id="text2">{this.state.hidden ? "Show System Prompt" : "Hide System Prompt" }</text>
                </g>
              </svg>
            </button>);
    }
}

